import axios from "axios";
import { queryCache } from "react-query";

interface PrefetchQueryObject {
  prefetchRate: () => Promise<void>;
  prefetchProcessingFee: () => Promise<void>;
}

export const usePrefetchQuery = (): PrefetchQueryObject => {
  const prefetchRate = async (): Promise<void> => {
    await queryCache.prefetchQuery("rate", async (key: string) => {
      try {
        const res = await axios.get("/rate");
        return res.data;
      } catch (err) {
        return;
      }
    });
  };
  const prefetchProcessingFee = async (): Promise<void> => {
    await queryCache.prefetchQuery("processing_fee", async (key: string) => {
      try {
        const res = await axios.get("/processing_fee");
        return res.data;
      } catch (err) {
        return;
      }
    });
  };

  return {
    prefetchRate,
    prefetchProcessingFee,
  };
};
